import { render, staticRenderFns } from "./activity-sales.vue?vue&type=template&id=4d82c833&scoped=true&"
import script from "./activity-sales.vue?vue&type=script&lang=js&"
export * from "./activity-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82c833",
  null
  
)

export default component.exports